export default {
	yourTemples: "Seus Templos",
	createNew: "Criar novo templo",
	noTemple: "Nenhum templo",
	createDialog: {
		title: "Criar Novo Templo",
		name: "Nome do Templo",
		nameHint: "Inicial maiúscula em cada palavra (ou tudo em maiúsculas)",
		acronym: "Sigla",
		acronymHint: "2-10 caracteres em maiúsculas, apenas letras e números. Será usada como identificador.",
		slugTaken: "Essa sigla já está em uso. Escolha outra.",
	},
	roles: {
		title: "Papel",
		owner: "Proprietário",
		admin: "Administrador",
		member: "Membro",
	},
	settings: "Configurações do Templo",
	publicAgenda: {
		navLabel: "Agenda pública",
		enableLabel: "Habilitar agenda pública",
		enableHint: "Publica uma página com link único onde as pessoas veem os rituais e podem reservar",
		linkLabel: "Link público",
		linkHint: "Compartilhe este link. Ele identifica seu templo com segurança.",
		rotateLink: "Gerar novo link",
		linkCopied: "Link copiado!",
		linkRotated: "Novo link gerado. O anterior deixou de funcionar.",
		acceptReservations: "Aceitar reservas",
		acceptReservationsHint: "Permite que as pessoas reservem presença nos rituais publicados",
		requirePhone: "Exigir telefone",
		requireEmail: "Exigir e-mail",
		requirePhoto: "Exigir foto",
		requirePhotoHint: "O consulente tira uma foto (webcam) para concluir a reserva.",
		seeNotifications: "Ver notificações de reserva",
		agendaWindowDays: "Janela da agenda (dias)",
		agendaWindowDaysHint: "Quantos dias à frente mostrar rituais",
		welcomeText: "Descrição curta",
		welcomeTextHint: "Aparece no topo da página pública, abaixo do nome (opcional)",
		longDescription: "Descrição longa",
		longDescriptionHint: "Aparece na aba “Mais informações” (opcional)",
		visibleFields: {
			title: "Mostrar na página pública",
			hint: "Dados do cadastro do terreiro. Só aparece o que estiver marcado.",
			phone: "Telefone",
			whatsapp: "WhatsApp",
			email: "E-mail",
			address: "Endereço",
			instagram: "Instagram",
			facebook: "Facebook",
			notRegistered: "não cadastrado",
		},
		qrCode: "QR code",
		rotateConfirm: {
			title: "Gerar novo link?",
			warning: "O link atual deixará de funcionar imediatamente. Quem já tiver o link antigo não conseguirá mais acessar a agenda.",
			instruction: "Para confirmar, digite o código abaixo:",
			mismatch: "O código não confere.",
			confirm: "Gerar novo link",
		},
		qrDialog: {
			title: "QR code da agenda",
			hint: "Baixe ou imprima para divulgar. Ao apontar a câmera, a pessoa abre a agenda pública.",
			download: "Baixar",
			print: "Imprimir",
		},
	},
	settingsLabels: {
		defaultCountryCode: "Código do país padrão",
		defaultCountryCodeHint: "Vem preenchido ao lado do telefone no cadastro.",
		templeData: "Dados do Templo",
		general: "Geral",
		contact: "Contato",
		address: "Endereço",
		schedule: "Funcionamento",
		visualIdentity: "Identidade Visual",
		printing: "Impressão",
		email: "Email",
		notifications: "Notificações",
		name: "Nome do Templo",
		tradition: "Tradição",
		cnpj: "CNPJ",
		razaoSocial: "Razão Social",
		description: "Descrição",
		foundedAt: "Data de Fundação",
		phone: "Telefone",
		whatsapp: "WhatsApp",
		templeEmail: "E-mail do Templo",
		instagram: "Instagram",
		facebook: "Facebook",
		saved: "Configurações salvas com sucesso!",
	},
	schedule: {
		title: "Dias e Turnos de Funcionamento",
		morning: "Manhã",
		afternoon: "Tarde",
		evening: "Noite",
		days: {
			mon: "Segunda-feira",
			tue: "Terça-feira",
			wed: "Quarta-feira",
			thu: "Quinta-feira",
			fri: "Sexta-feira",
			sat: "Sábado",
			sun: "Domingo",
		},
	},
	emailSettings: {
		sendReportOnClose: "Enviar relatório ao fechar ritual",
		sendReportOnCloseHint: "Envia automaticamente o relatório por email para administradores ao fechar um ritual",
		birthdayEmailEnabled: "Enviar email de aniversariantes do dia",
		birthdayEmailEnabledHint: "Envia um email no início da manhã com a lista de aniversariantes do dia",
		birthdayRecipients: "Destinatários",
		birthdayRecipientsHint: "Selecione quem deve receber o email de aniversariantes",
		recipientAdmins: "Administradores",
		recipientAllUsers: "Todos os usuários",
		recipientGuides: "Membros da corrente",
		receiptEmailEnabled: "Enviar recibo por email",
		receiptEmailEnabledHint: "Ao registrar um pagamento, envia automaticamente o recibo por email para o membro (se tiver email cadastrado)",
	},
	attendanceTimeSettings: {
		title: "Atendimento",
		timeSectionTitle: "Tempo de atendimento nas fichas",
		timeSectionDescription: "Controla os indicadores visuais de tempo na tela de chamada de fichas",
		warningMinutes: "Tempo de alerta (amarelo)",
		warningMinutesHint: "Ficha fica amarela após esse tempo (minutos)",
		limitMinutes: "Tempo limite (vermelho)",
		limitMinutesHint: "Ficha fica vermelha após esse tempo (minutos)",
	},
	financialSettings: {
		tabGeneral: "Geral",
		sectionTitle: "Cobranças Automáticas",
		advanceDays: "Dias de antecedência",
		advanceDaysHint: "Gerar cobranças {n} dias antes do vencimento (entre 5 e 25)",
		defaultDueDays: "Vencimento padrão (dias)",
		defaultDueDaysHint: "Cobrança avulsa sem vencimento informado nasce com {n} dias de prazo a partir de hoje (entre 0 e 20; 0 = vence hoje)",
		sendPaymentReminders: "Enviar lembretes de vencimento",
		sendPaymentRemindersHint: "Envia um email de lembrete 3 dias antes do vencimento",
		sendOverdueAlerts: "Enviar avisos de atraso",
		sendOverdueAlertsHint: "Envia um email de alerta 1 dia após o vencimento",
		allowEditAmountOnSettle: "Permitir editar o valor ao dar baixa",
		allowEditAmountOnSettleHint: "Quando ativado, o operador pode ajustar o valor ao dar baixa numa cobrança ou mensalidade. Desativado, a baixa quita pelo valor exato cobrado.",
		residualChargePolicy: "Cobrança do saldo residual ao editar valor na baixa",
		residualChargePolicyHint: "Define o que acontece com a diferença quando o valor pago for menor que o valor cobrado: perdoar, perguntar a cada baixa, ou gerar automaticamente uma cobrança pelo saldo restante.",
		residualChargePolicyOptions: {
			FORGIVE: "Desativado — o saldo restante é perdoado",
			ASK: "Perguntar no momento da baixa",
			ALWAYS: "Sempre cobrar o saldo restante",
		},
	},
	whatsappSettings: {
		sectionTitle: "Alertas por WhatsApp",
		sectionDescription: "Mensagens enviadas pelo número oficial do ORI, citando o nome do templo.",
		enabled: "Ativar alertas por WhatsApp",
		enabledHint: "Envia os avisos financeiros também por WhatsApp, além do e-mail",
		sendPaymentReminders: "Lembretes de vencimento",
		sendPaymentRemindersHint: "Envia um lembrete por WhatsApp antes do vencimento das cobranças",
		sendOverdueAlerts: "Avisos de atraso",
		sendOverdueAlertsHint: "Envia um aviso por WhatsApp quando a cobrança fica em atraso",
		sendPaymentConfirmations: "Confirmações de pagamento",
		sendPaymentConfirmationsHint: "Envia uma confirmação por WhatsApp quando um pagamento é aprovado",
		sendAdminAlerts: "Alertas para administradores",
		sendAdminAlertsHint: "Envia aos administradores avisos de pagamento recebido, despesas, duplicidade e fechamento pendente (cada admin precisa ativar o WhatsApp no próprio perfil)",
		optInNote: "Cada pessoa recebe mensagens apenas se tiver telefone válido e consentimento (opt-in) registrado no cadastro.",
	},
	notifications: {
		channelsTitle: "Canais de envio",
		channelsDescription: "Escolha por qual canal cada aviso é enviado. O e-mail é o canal padrão; o WhatsApp é um canal adicional.",
		emailChannel: "E-mail",
		emailChannelDesc: "Canal principal, sempre disponível para quem tem e-mail cadastrado.",
		channelDefault: "Padrão",
		whatsappChannel: "WhatsApp",
		whatsappChannelDesc: "Mensagens pelo número oficial do ORI, citando o nome do templo.",
		whatsappOptInNote: "Cada pessoa só recebe se tiver telefone válido e consentimento (opt-in) registrado no cadastro.",
		whatsappAddonChip: "Contratar add-on",
		whatsappAddonNote: "Os alertas por WhatsApp são um add-on e não estão incluídos no seu plano atual. Contrate o add-on para ativar este canal.",
		colEvent: "Evento",
		colEmail: "E-mail",
		colWhatsapp: "WhatsApp",
		sectionMember: "Cobranças (para o membro)",
		sectionAdmin: "Alertas para administradores",
		sectionReports: "Relatórios e relacionamento",
		eventNewCharge: "Nova cobrança gerada",
		eventNewChargeHint: "Aviso enviado quando uma nova cobrança ou mensalidade é criada.",
		eventReminder: "Lembrete de pagamento",
		eventReminderDaysPre: "Enviar",
		eventReminderDaysPost: "dias antes do vencimento (0 a 3; 0 = no dia)",
		eventOverdue: "Cobrança em atraso",
		eventOverdueHint: "Aviso enviado no dia seguinte ao vencimento.",
		eventConfirmation: "Pagamento confirmado / recibo",
		eventConfirmationHint: "Comprovante enviado quando o pagamento é aprovado.",
		eventAdmin: "Alertas para a diretoria",
		eventAdminHint: "Pagamento recebido, despesas a vencer/em atraso, duplicidade e fechamento mensal pendente.",
		eventClosingReport: "Relatório de fechamento mensal",
		eventClosingReportHint: "Enviado com o PDF ao fechar o mês.",
		eventBirthday: "Aniversário de membro",
		eventBirthdayHint: "Lista de aniversariantes do dia, no início da manhã.",
		sectionReservations: "Agenda pública",
		eventNewReservation: "Nova reserva",
		eventNewReservationHint: "Avisa os administradores quando uma reserva pública é confirmada e entra na fila de análise.",
		recipientsLabel: "Destinatários:",
		footNote: "Avisos essenciais (nova cobrança, falha de débito) são sempre enviados quando o canal está ativo. O WhatsApp exige que a pessoa tenha dado opt-in.",
		alwaysTooltip: "Sempre enviado quando o canal está ativo",
		whatsappOffTooltip: "Ative o canal WhatsApp acima",
		emailOnlyTooltip: "Disponível apenas por e-mail",
	},
	printing: {
		autoPrint: "Imprimir automaticamente ao criar ficha",
		autoPrintHint: "Quando ativado, a impressão será disparada sempre que uma ficha for criada durante o ritual",
		autoPrintScheduled: "Imprimir fichas de rituais agendados",
		autoPrintScheduledHint: "Quando ativado, fichas distribuídas em rituais futuros também serão impressas automaticamente",
		paperWidth: "Largura do papel",
		customMessage: "Mensagem personalizada",
		customMessageHint: "Texto exibido no rodapé do comprovante (máx. 200 caracteres)",
		receiptEnabled: "Habilitar impressão de recibo",
		receiptEnabledHint: "Exibe o botão de imprimir recibo nas movimentações financeiras pagas",
		showLogo: "Imprimir logotipo do templo na ficha",
		showLogoHint: "Quando desativado, a ficha será impressa sem o logotipo do templo",
		previewBeforePrint: "Ver o recibo antes de imprimir",
		previewBeforePrintHint: "Mostra o recibo na tela, com o botão de imprimir dentro, para conferir nome, valor e data antes de gastar papel. Desligado, imprime direto.",
		previewReceiptTitle: "Recibo",
		previewHint: "Confira antes de gastar papel.",
		previewPrint: "Imprimir",
		previewPrintFailed: "Não foi possível abrir a impressão. Tente novamente.",
		kioskManualHint: "Para configurar a impressão silenciosa, consulte o",
		kioskManualLink: "manual de impressão",
		testPrint: "Imprimir página de teste",
	},
	pixSettings: {
		disabledByMp: "Com a integração do Mercado Pago ativa, esta função está desabilitada — as cobranças usam o PIX dinâmico do Mercado Pago.",
		enabled: "Incluir QR Code PIX nos emails de cobrança",
		enabledHint: "Quando ativado, os emails de lembrete e atraso incluirão um QR Code PIX com o valor preenchido",
		sectionDescription: "Configure a chave PIX que será usada para gerar o QR Code.",
		keyType: "Tipo da chave PIX",
		key: "Chave PIX",
		keyHint: "CPF, CNPJ, email, telefone ou chave aleatória",
		keyTypeRequired: "Escolha o tipo da chave antes de informar a chave PIX",
		keyInvalid: {
			CPF: "CPF inválido — confira os 11 dígitos",
			CNPJ: "CNPJ inválido — confira os 14 dígitos",
			EMAIL: "E-mail inválido ou longo demais (máx. 77 caracteres)",
			PHONE: "Telefone inválido — informe DDD e número, de um telefone do Brasil",
			RANDOM: "Chave aleatória inválida — são 36 caracteres com hífens, exatamente como o banco forneceu",
		},
		recipientName: "Nome do beneficiário",
		recipientNameHint: "Nome que aparecerá no PIX (máx. 25 caracteres)",
		city: "Cidade",
		cityHint: "Cidade do beneficiário (máx. 15 caracteres)",
	},
	preSenhaSettings: {
		usePreSenha: "Usar pré-senha no atendimento",
		usePreSenhaHint: "Ativa o sistema de chamada por pré-senha na página de distribuição de fichas",
	},
	invites: "Convites",
	pendingInvites: "Convites Pendentes",
	noInvites: "Nenhum convite pendente",
	inviteCode: "Código de Convite",
	inviteCodeDescription: "Compartilhe este código para convidar membros",
	generateCode: "Gerar Código",
	revokeCode: "Revogar Código",
	codeExpires: "Expira em",
	copyCode: "Copiar código",
	codeCopied: "Código copiado!",
	inviteByEmail: "Convidar por Email",
	sendInvite: "Enviar Convite",
	email: "Email do convidado",
	role: "Função",
	ritualFunction: "Função Ritual",
	ritualFunctionHint: "Ex: Médium, Cambono, Ogã (opcional)",
	inviteSent: "Convite enviado com sucesso!",
	inviteRevoked: "Convite revogado",
	expired: "Expirado",
	pending: "Pendente",
};
